import { useQuery } from '@tanstack/react-query';
import projectPlanDraftService from '@services/projectPlanDraft';
import { ProjectPlanDraft } from '@models/projectPlanDraft.model';

export const MY_PROJECT_PLAN_DRAFTS_QUERY_KEY = 'myProjectPlanDrafts';

/** Drafts the caller can resume: GENERATING or READY. Failed/imported/saved ones are not listed. */
export const isResumableDraft = (draft: ProjectPlanDraft): boolean =>
  draft.status === 'GENERATING' || draft.status === 'READY';

/**
 * Sprint 36, story-189. Polls every 5 s while any listed draft is still GENERATING so the panel's
 * status chip and progress label stay live. `enabled` carries the flag/role gate from the caller.
 */
export const useMyProjectPlanDrafts = (enabled = true) => {
  return useQuery({
    queryKey: [MY_PROJECT_PLAN_DRAFTS_QUERY_KEY],
    queryFn: async () => (await projectPlanDraftService.getMyProjectPlanDrafts()).filter(isResumableDraft),
    enabled,
    retry: false,
    refetchInterval: (query) => (query.state.data?.some((d) => d.status === 'GENERATING') ? 5000 : false),
  });
};

export default useMyProjectPlanDrafts;
